import { NazorgOverview } from '../translations-types';

const translations: NazorgOverview = {
  title: 'Nazorg overzicht',
  voorzorg: 'Voorzorg',
  nazorg: 'Nazorg',
  matching: 'Afspraken koppeling',
  salonizedAppointments: 'Agenda',
  noResults: 'Nog geen afgeronde vragenlijsten.',
  sent: 'Verstuurd',
  notSent: 'Niet verstuurd',
  sentNotCompleted: 'Verstuurd, nog niet ingevuld.',
  careNoAppointments: 'Geen gematchte afspraken.',
  viewResults: 'Bekijk resultaten',
  sendAction: 'Verstuur',
  sendConfirm: 'De vragenlijst wordt (opnieuw) naar de klant gemaild.',
  sendSuccess: 'Vragenlijst verstuurd.',
};

export default translations;
